export default "__VITE_ASSET__Cm11YH9h__"